

























































































































































































import { useRouter, useFormat } from '@ideavivat/vivat-2';
import {
  defineComponent, reactive, ref, Ref, onMounted, watch, computed,
} from '@vue/composition-api';

import {
  getLots,
  updateWithdrawFill,
  getMaterials,
  getWithdraw,
  getWithdrawItems,
  searchWithdrawItems,
  getSuppliers,
  updateWithdrawItem,
} from '@/api/index';
import withdrawItems from '@/table/Withdraw/confirm';
import withdrawItemWithAmountTableOption from '@/table/Withdraw/confirm-with-amount';
import depositItem from '@/table/Withdraw/deposit-confirm';
import depositItemWithAmountTableOption from '@/table/Withdraw/deposit-confirm-with-amount';

import CommonModalWithPreset from '@/components/CommonModalWithPreset.vue';
import StickyFooterActionBar from '@/components/StickyFooterActionBar.vue';

const NOW = useFormat.date().computerShortDate();

const Confirm = defineComponent({
  components: {
    CommonModalWithPreset,
    StickyFooterActionBar,
  },
  props: {
    edit: { default: false },
    title: { default: '' },
  },
  setup(props) {
    const { route, router } = useRouter();
    const toDate = (date: string): string => useFormat.date(date).displayFullThaiDate();
    const getLotsResult = (data: any) => data.data.data;
    const step = ref(1);
    const refetchQuery = ref(false);
    const confirmModal = ref(null);
    const confirmModalError = ref(null);
    const withdraw = ref({
      id: -1,
      type: 'WITHDRAW',
    });
    const getSuppliersResult = (data: any) => data.data.data;
    const withdrawTableData = ref({ total: 0, data: [] });
    const forceRender = ref(false);
    const errorHandle = ref(false);
    function open() {
      (confirmModalError.value as any).open();
    }
    const form = reactive({
      type: '',
      status: 'PENDING',
      remarks: '',
      items: [],
      call: async () => {
        if (props.edit) console.log('TO DO');
        else {
          const updateWithdraw = await updateWithdrawFill(withdraw.value.id, { items: (computedFillInput.value as any), remarks: form.remarks });
          errorHandle.value = updateWithdraw.success;
          if (errorHandle.value === false) open();
        }
        if (errorHandle.value === true) (confirmModal.value as any).compose({ action: 'เบิกของ' });
      },
      state: {
        value: 'READY',
      },
    });
    const computedFillInput = computed(() => form.items.map((item: any) => ({
      withdrawRequestItemId: item.id,
      lotId: item.lot?.id,
      amount: item.addedAmount,
    })));

    const filter = computed(() => ({
      filterWithdrawRequestId: route.value.params.id,
    }));

    async function getWithdrawQuery() {
      withdraw.value = (await getWithdraw(route.value.params.id)).data;
    }
    onMounted(async () => {
      await getWithdrawQuery();
    });

    // Use to store which item already select
    const selectedItemId: Ref<number[]> = ref([]);
    // Use to finallize value that send to search api (Search api for find whole item that user choose to create PR)
    const searchValue: Ref<string | number[] | null> = ref(null);
    // Use to select item;
    function selectItem(id: number) {
      const hitIndex = selectedItemId.value.indexOf(id);
      if (selectedItemId.value.indexOf(id) > -1) selectedItemId.value.splice(hitIndex, 1);
      else selectedItemId.value.push(id);
      if (selectedItemId.value.length !== withdrawTableData.value.total) searchValue.value = selectedItemId.value;
      else searchValue.value = 'ALL';
    }
    function clearSelect() {
      selectedItemId.value = [];
      searchValue.value = [];
    }
    function selectAll() {
      forceRender.value = true;
      selectedItemId.value = withdrawTableData.value.data.map((subJob: any) => subJob.id);
      searchValue.value = 'ALL';
      forceRender.value = false;
    }

    // Watch when route change;
    watch(() => route.value.params.prId, async (newVal, oldVal) => {
      if (newVal !== oldVal && newVal !== '') {
        await getWithdrawQuery();
        step.value = 1;
        clearSelect();
        refetchQuery.value = true;
      }
    });

    // use this to manually paginate create pr page;
    const page = ref(1);
    const PERPAGE = 8;
    const receiveWithdrawPaginator = computed(() => ({
      perPage: PERPAGE,
      total: form.items.length,
      from: (page.value - 1) * PERPAGE,
      to: (page.value * PERPAGE),
      currentPage: 1,
      lastPage: form.items.length === 0 ? 1 : Math.ceil(form.items.length / PERPAGE),
      totalPages: form.items.length === 0 ? 1 : Math.ceil(form.items.length / PERPAGE),
    }));
    async function forward() {
      const result = await searchWithdrawItems({ ids: searchValue.value, withdrawRequestId: route.value.params.id });
      form.items = result.map((item: any) => ({
        id: item.id,
        amount: parseFloat(item.amount).toLocaleString('th-TH', { minimumFractionDigits: 0, maximumFractionDigits: 2 }),
        filledAmount: parseFloat(item.filled_amount).toLocaleString('th-TH', { minimumFractionDigits: 0, maximumFractionDigits: 2 }),
        addedAmount: parseFloat(`${item.amount - item.filled_amount}`).toLocaleString('th-TH', { minimumFractionDigits: 0, maximumFractionDigits: 2 }),
        bom_item: item.bom_item,
        material: item.material || item.bom_item.material,
        oldMatId: item.material.id || item.bom_item.material.id,
        lot: null,
        target_date: item.target_date,
        created_at: item.created_at,
        broken: item.broken,
      }));
      step.value = 2;
    }
    async function backward() {
      step.value = 1;
    }
    const displayData = computed(() => {
      if (form.items.length < receiveWithdrawPaginator.value.to) return form.items.slice(receiveWithdrawPaginator.value.from, form.items.length);
      return form.items.slice(receiveWithdrawPaginator.value.from, receiveWithdrawPaginator.value.to);
    });

    // Hook when CommonRichTableWithAxios finish fetching data;
    // use this to check total record & how many user has select item.
    function receiveWithdrawData(data: any) {
      withdrawTableData.value = {
        data: data.data,
        total: data.total,
      };
    }

    const computedWithdrawTableOption = computed(() => {
      if (withdraw.value.type === 'WITHDRAW') return { base: withdrawItems, amount: withdrawItemWithAmountTableOption };
      return { base: depositItem, amount: depositItemWithAmountTableOption };
    });

    const getMaterialsResult = (data: any) => data.data.data;

    async function updateWithdrawItemAction(index: number, id: number) {
      await updateWithdrawItem(id, { materialId: (form.items[index] as any).material.id });
      (form.items[index] as any).oldMatId = (form.items[index] as any).material.id;
    }

    return {
      NOW,
      toDate,

      getSuppliers,
      getSuppliersResult,

      withdraw,
      forceRender,
      confirmModal,
      confirmModalError,
      step,
      forward,
      backward,

      filter,
      getWithdrawItems,
      refetchQuery,
      selectItem,
      selectedItemId,
      searchValue,

      clearSelect,
      selectAll,
      form,

      displayData,
      page,
      pagination: receiveWithdrawPaginator,

      computedWithdrawTableOption,

      withdrawTableData,
      receiveWithdrawData,

      getLots,
      getLotsResult,

      getMaterialsResult,
      getMaterials,

      updateWithdrawItemAction,
    };
  },
});

export default Confirm;
